import { useNavigate } from 'react-router-dom';

const platforms = [
  { name: 'YouTube Playlists', route: '/Backend_FireBase_Yt', logo: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg' },
  { name: 'Coursera', route: '/Backend_FireBase_Coursera', logo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU' },
  { name: 'Udemy Courses', route: '/Backend_FireBase_Udemy', logo: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg' },
  { name: 'Geeks For Geeks', route: '/Backend_FireBase_Gfg', logo: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg' },
  { name: 'Coding Platforms', route: '/Backend_FireBase_Codplat', logo: 'https://img.freepik.com/premium-vector/continuous-line-building-city-logo-design_15473-14266.jpg?semt=ais_hybrid' }
];

export function FireBase() {
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <>
      <h1 className="html_head">Links are below</h1>
      <p className="html_para">
        These are the platforms for your <strong>FireBase</strong> study purposes. Utilize these recommended platforms to explore and gain knowledge for practice. This is for <strong>educational purposes</strong> to help you learn in a shorter time.
      </p>
      <h3 className="reco_html">Recommended Platforms</h3>

      {platforms.map((platform, index) => (
        <div key={index} className="container_html_pg">
          <img className="html_logo_yt" style={{ height: '90px', width: '90px' }} src={platform.logo} alt={platform.name} />
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>{platform.name} &#9754;</h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => handleNavigation(platform.route)}>Click Me</button>
          </div>
        </div>
      ))}
    </>
  );
}

export default FireBase;
